import { createFileRoute } from "@tanstack/react-router";
import { ExtractionTaskEditPage } from "@client/components/doc-center/extraction-task/extraction-task-edit-page";

export const Route = createFileRoute(
  "/_app/data-center/extraction/edit/$taskId",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { taskId } = Route.useParams();
  return <ExtractionTaskEditPage taskId={taskId} />;
}
